import { Component, OnInit } from '@angular/core';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { ToplineService } from '../../service/topline.service';
import { NotifierService } from 'angular-notifier';
import { RepoApiService } from '../../service/repo-api.service';

@Component({
  selector: 'app-edit-group',
  templateUrl: './edit-group.component.html',
  styleUrls: ['./edit-group.component.scss']
})
export class EditGroupComponent implements OnInit {
  public selectedTableInGroup:any[] = [];
  public groupName:any;
  public showingTableList:boolean = false;
  public selectedTable:any = [];
  public combineTableListForEditGroup = [];
  public tableListBasedOnSelectedSheet = [];
  public groupexit:boolean = false;
  constructor(
    public eService:ExcelViewerService,
    public toplineService:ToplineService,
    public notifier:NotifierService,
    private repoService:RepoApiService,
  ) { }

  ngOnInit(): void {
    this.getAllTableandGroupOfThisSheet();
    this.changeEditTableDataList();
  }

  ngOnDestroy(){
    this.closeEditGroupComponent();
  }

  getAllTableandGroupOfThisSheet(){
    console.log("this.eService.selectedSheet['value']['kpis'] ====> ",this.eService.selectedSheet['value']['kpis'])
    Object.keys(this.eService.selectedSheet['value']['kpis']).forEach((va) =>{
      let obj = {
        id:this.eService.selectedSheet['value']['kpis'][va]['kpi_id'],
        type:this.eService.selectedSheet['value']['kpis'][va]['type'],
        label:va,
        name:this.eService.selectedSheet['value']['kpis'][va]['name'],
        options:this.eService.selectedSheet['value']['kpis'][va]['options']
      };
      this.tableListBasedOnSelectedSheet.push(obj);
    })
  }


  closeEditGroupComponent(){
    this.eService.isEditGroupToplineComponent = false;
    this.selectedTableInGroup = [];
    this.groupName = "";
    this.showingTableList = false;
    this.selectedTable = [];
    this.combineTableListForEditGroup = [];
    this.tableListBasedOnSelectedSheet = [];
    this.groupexit = false;
  }


   changeEditTableDataList(){
    if(Object.keys(this.eService.editGroupToplineDetails['options']).length){
      console.log("this.eService.editGroupToplineDetails ====> ",this.eService.editGroupToplineDetails)
      // let parentName = this.eService.editGroupToplineDetails['parent'].split("$_$-$_$");
      // this.groupName = parentName[parentName.length-1];
      this.groupName = this.eService.editGroupToplineDetails['name'];
      this.showingTableList = true;
      Object.keys(this.eService.editGroupToplineDetails['options']).forEach((key) =>{
      let obj = {
        id:this.eService.editGroupToplineDetails['options'][key]['kpi_id'],
        type:this.eService.editGroupToplineDetails['options'][key]['type'],
        label:key,
        name:this.eService.editGroupToplineDetails['options'][key]['name'],
        options:this.eService.editGroupToplineDetails['options'][key]['options']
      };
      this.selectedTableInGroup.push(obj);
      })
      this.selectedTable = this.selectedTableInGroup;
      this.combineTableListForEditGroup = [...this.selectedTableInGroup];
      this.tableListBasedOnSelectedSheet.forEach((va) =>{
        this.groupexit = false;
        this.validGroup(va);
        if(!this.groupexit){
          this.combineTableListForEditGroup.push(va);
        }
      })

    }
  }

  validGroup(va){
    if(va['type'] == 'level'){
      if(+va['table_id'] == +this.eService.editGroupToplineDetails['kpi_id'] || +va['id'] == +this.eService.editGroupToplineDetails['kpi_id']){
        this.groupexit = true;
        return;
      }else{
        Object.keys(va['options']).forEach((key) =>{
          this.validGroup(va['options'][key]);
        })
      }
    }else{
      if(va['table_id'] == this.eService.editGroupToplineDetails['kpi_id']){
        this.groupexit = true;
        return;
      };
    }
  }

  showingTableListComponent(){
    this.showingTableList = !this.showingTableList;
  }


  addtoTableInGroup(table:any){
    let exitTable = this.selectedTable.findIndex((va) =>{
      return va['id'] === table['id'];
    })
    if(exitTable === -1){
      this.selectedTable.push(table);
    }else{
      this.selectedTable.splice(exitTable,1);
    }
  }


  getSelectedTableName(len){
    let name = "";
    this.selectedTable.forEach((va) =>{
      name += va['name'];
      name += ',';
    })
    if(name.length > len){
      return name.substring(0,len) + '....';
    }
    return name.substring(0,name.length-1);
  }


  checkedOrNot(table){
    let exitTable = this.selectedTable.findIndex((va) =>{
      return va['id'] === table['id'];
    })
    return exitTable === -1 ? false : true;

  }

  onUpdate(){
    let body = {};
    body['name'] = this.groupName;
    body['group_id'] = this.eService.editGroupToplineDetails['kpi_id']
    body['parent_id'] = this.eService.editGroupToplineDetails['parent_id']
    body['file_id'] = this.toplineService.excelviewer_fileUUID;
    body['sheet_id'] = this.eService.selectedSheet['value']['sheet_id'];
    body['selected_tables'] = [];
    this.selectedTable.forEach((va) =>{
      let obj = {};
      obj['id'] = va['id'];
      obj['label'] = va['label'];
      obj['name'] = va['name'];
      body['selected_tables'].push(obj);
    })
    this.repoService.updategroupTableInKpis(body).subscribe((res) =>{
      if(res['status'] == 1){
        this.closeEditGroupComponent();
        this.eService.refreshFilterOptions();
        let parent_id = res["parent_id"];
        this.eService.kpiParentId = parent_id.split("$_$-$_$");
        // this.eService.getFilterOptions();
      }else{
        this.notifier.notify('error','Something Went Wrong')
      }
    })
  }

  validateForm(){
    if(!this.groupName || this.groupName == ''){
      this.notifier.notify('error','Please Enter Group Name');
      return 0;
    }
    if(this.selectedTable.length === 0){
      this.notifier.notify('error','Please select table to group');
      return 0;
    }else{
      return 1;
    }
  }


}
